import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import { loadLocaleMessages } from '@/utils';

Vue.use(Vuex);
Vue.use(VueI18n);

const { localStorage } = global;

const browserLang = window.navigator.language || window.navigator.browserLanguage;
const browserLangReal = browserLang.match(/\S*(?=-)/)
  ? browserLang.match(/\S*(?=-)/)[0] : browserLang;

if (localStorage && localStorage.getItem('userLang') === 'undefined') {
  localStorage.setItem('userLang', 'zh-CN')
};

let language = localStorage ? localStorage.getItem('userLang') : '';

if (!language) language = ((browserLangReal === 'zh' || browserLangReal === 'zh-CN') ? 'zh-CN' : process.env.VUE_APP_I18N_LOCALE);
// 没部署
const states = {
  language,
};
console.log('l', language, process.env.VUE_APP_I18N_LOCALE, browserLang, browserLangReal)
const mutations = {
  SET_LANG(state, lang) {
    state.language = lang;
  },
  UPDATE_CODEMAPS(state, payload) {
    state.codeMaps = Object.assign({}, payload);
  },
};

const actions = {
  // 初始化语言
  initLang({ state, commit }, lang) {
    return new Promise((resolve) => {
      lang = lang || state.language;
      const i18n = new VueI18n({
        locale: lang,
        fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-CN',
        messages: loadLocaleMessages(),
      });
      if (localStorage) {
        localStorage.setItem('userLang', lang);
      }
      commit('SET_LANG', lang);
      ElementLocale.i18n((key, value) => i18n.t(key, value));
      resolve(i18n);
    });
  },
  updateLang({ commit }, { i18n, lang }) {
    return new Promise((resolve) => {
      if (localStorage) {
        localStorage.setItem('userLang', lang);
      }
      commit('SET_LANG', lang);
      i18n.locale = lang;
      resolve();
    });
  },
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: states,
  mutations,
  actions,
});
